'use client';

import Image from '@alltrails/core/components/Image';
import Button from '@alltrails/denali/components/Button';
import Heading from '@alltrails/denali/components/Heading';
import logInstallPromptClicked from '@alltrails/amplitude/events/logInstallPromptClicked';
import QRCodeDownload from './QRCodeDownload';
import phoneCondensedSrc from './images/condensed.avif';
import phoneCondensedCutoffSrc from './images/condensed-cutoff.avif';
import styles from './AppInstallSection.module.scss';
import Typography from '@alltrails/core/components/Typography';
import useIsMobileSizedScreen from '@alltrails/denali/hooks/useIsMobileSizedScreen';
import useAppsFlyerDeeplink from '@alltrails/install-prompt/hooks/useAppsFlyerDeeplink';

// Design: https://www.figma.com/design/0yD9YXMqR17WjqlJMRQwpd/2026-Homepage-update?node-id=797-24720&m=dev

const AppInstallSection = () => {
  const isMobileSizedScreen = useIsMobileSizedScreen();
  const getDeeplink = useAppsFlyerDeeplink({ isEnabled: true });

  const handleClick = () => {
    logInstallPromptClicked({
      install_prompt_location: 'home page',
      install_prompt_type: 'interstitial',
      install_prompt_source: 'native_with_appsflyer_link'
    });
    window.location.href = getDeeplink();
  };

  // TODO add translations https://alltrails.atlassian.net/browse/GROW-15823
  return (
    <section className={styles.container}>
      <div className={styles.descriptionContainer}>
        <div className={styles.content}>
          <Heading as="h2" size="600" className={styles.title}>
            Do more in the AllTrails app
          </Heading>
          <Typography variant="text300">
            Plan with confidence, track every adventure, and download offline maps so you&apos;re ready for anything
          </Typography>
          {isMobileSizedScreen ? (
            <Button className={styles.button} text="Download the app" variant="primary" onClick={handleClick} />
          ) : (
            <QRCodeDownload />
          )}
        </div>
      </div>
      <div className={styles.imageContainer}>
        <Image
          sizes="100vw"
          src={isMobileSizedScreen ? phoneCondensedSrc : phoneCondensedCutoffSrc}
          alt="Three smartphone screens illustrating features in the AllTrails app: Record your activities, create your own route, and explore trails even without service."
          className={styles.image}
        />
      </div>
    </section>
  );
};

export default AppInstallSection;
